import React from "react";
var __jsx = React.createElement;
import entityBrandingStoryblokService from "@lib/storyblok/services/financial-entity-services/entity-branding-service";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import EntityLogo from "@modules/shared/logos/entity-logo";
import { downloadDocType, openLink } from "@lib/util/link-redirection-ops";
import { DocumentType } from "types/document-type";
import ImageRender from "@modules/layout/components/shared/image-render";
import useTrackEvent from "@lib/hooks/use-track-event";
import { MIXPANEL_EVENTS } from "@lib/mixpanel/mixpanel.event-list";
import APP_CONFIGURATION from "@lib/app.config";
import Icons from "@modules/icons";
import ContactInfo from "../contact-info";
import { BREAKPOINTS } from "@lib/constants";
import { useMediaQuery } from "react-responsive";
import useCssModules from "@lib/hooks/use-css-modules";
function BusinessInformation(_ref) {
  var _cssModules$footers$f;
  let {
    instagramURL,
    facebookURL,
    reclamationBookURL
  } = _ref;
  const t = useTranslations("Shared.Layout");
  const {
    0: platformLogo,
    1: setPlatformLogo
  } = useState("");
  const trackEvent = useTrackEvent();
  const {
    hide_backed_by_in_footer
  } = APP_CONFIGURATION.config;
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  const {
    cssModules
  } = useCssModules();
  const {
    infoItemsContainerClassNames,
    entityLogoContainerClassNames,
    entityLogoClassNames,
    entityTextClassNames,
    borderColorClassNames,
    linksContainerClassNames,
    linksTitleClassNames,
    linkBookClassNames,
    linkSocialClassNames,
    linksPolicysClassNames,
    linksTermsClassNames
  } = (_cssModules$footers$f = cssModules === null || cssModules === void 0 ? void 0 : cssModules.footers.footerInterbank) !== null && _cssModules$footers$f !== void 0 ? _cssModules$footers$f : {};
  const {
    0: open,
    1: setOpen
  } = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const platformAsset = await entityBrandingStoryblokService.getPlatformContrastLogo();
        setPlatformLogo(platformAsset);
      } catch (error) {
        console.error("Error fetching icons", error);
      }
    };
    fetchData();
  }, []);
  return __jsx("section", {
    className: infoItemsContainerClassNames
  }, __jsx("div", {
    className: entityLogoContainerClassNames
  }, __jsx(ImageRender, {
    useImage: false,
    src: platformLogo,
    alt: "logo",
    className: entityLogoClassNames
  }), __jsx("p", {
    className: entityTextClassNames
  }, t("BUSINESS_MESSAGE")), !hide_backed_by_in_footer && __jsx("div", {
    className: "flex flex-col gap-4 items-start"
  }, __jsx("p", {
    className: ""
  }, t("BACKED_BY")), __jsx(EntityLogo, {
    height: 34
  }))), __jsx("div", {
    className: "flex flex-col gap-5 md:flex-row md:gap-[35px]"
  }, __jsx("div", {
    className: borderColorClassNames
  }), __jsx(ContactInfo, null), __jsx("div", {
    className: borderColorClassNames
  })), __jsx("div", {
    className: linksContainerClassNames
  }, __jsx("div", {
    className: "flex flex-row-reverse md:flex-col p-1 gap-7"
  }, __jsx("div", {
    className: "flex flex-col items-start"
  }, __jsx("p", {
    className: linksTitleClassNames
  }, t("CLAIMS_BOOK")), __jsx("button", {
    onClick: () => {
      openLink(reclamationBookURL);
      trackEvent(MIXPANEL_EVENTS.Home.CLAIMS_OPEN_BOOK);
    }
  }, __jsx(Icons.book, {
    className: linkBookClassNames
  }))), __jsx("div", {
    className: "flex flex-col flex-1"
  }, __jsx("p", {
    className: linksTitleClassNames
  }, t("FOLLOW_US_IN")), __jsx("div", {
    className: "flex gap-1"
  }, __jsx("button", {
    onClick: () => openLink(facebookURL)
  }, __jsx(Icons.facebook, {
    className: linkSocialClassNames
  })), __jsx("button", {
    onClick: () => openLink(instagramURL)
  }, __jsx(Icons.instagram, {
    className: linkSocialClassNames
  }))))), __jsx("div", {
    className: "flex self-center justify-between md:flex-col gap-2"
  }, __jsx("button", {
    onClick: () => downloadDocType(DocumentType.PRIVACY_POLICY)
  }, __jsx("p", {
    className: linksPolicysClassNames
  }, t("PRIVACY_POLICY"))), __jsx("button", {
    onClick: () => downloadDocType(DocumentType.TERMS_AND_CONDITIONS)
  }, __jsx("p", {
    className: linksTermsClassNames
  }, t("TERMS_AND_CONDITIONS"))))));
}
export default BusinessInformation;